
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '@/lib/firebase';
import { signOut } from 'firebase/auth';
import { Clock, LogOut, CheckCircle } from 'lucide-react';

const PendingApprovalPage = () => {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await signOut(auth);
            navigate('/login');
        } catch (error) {
            console.error("Logout failed", error);
        }
    };

    return (
        <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4 relative overflow-hidden">
            {/* Background Effects */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
                <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] bg-blue-600/20 rounded-full blur-[100px] animate-pulse"></div>
                <div className="absolute bottom-[-10%] left-[-10%] w-[500px] h-[500px] bg-purple-600/20 rounded-full blur-[100px] animate-pulse delay-1000"></div>
            </div>

            {/* Main Container */}
            <div className="relative z-10 w-full max-w-md mx-auto">
                <div className="text-center mb-8">
                    <h1 className="text-4xl font-black text-white italic tracking-tighter mb-2">
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">COIN</span>
                        <span className="text-white">TOCASH</span>
                    </h1>
                </div>

                <div className="bg-slate-900/50 backdrop-blur-xl border border-slate-800 p-8 rounded-[2rem] shadow-2xl">
                    {/* Success Icon */}
                    <div className="flex justify-center mb-6">
                        <div className="w-20 h-20 rounded-full bg-gradient-to-br from-blue-500/20 to-purple-500/20 border-2 border-blue-500/30 flex items-center justify-center animate-pulse">
                            <Clock className="w-10 h-10 text-blue-400" />
                        </div>
                    </div>

                    {/* Main Message */}
                    <h2 className="text-2xl font-bold text-white text-center mb-3">
                        회원가입 완료!
                    </h2>
                    <p className="text-slate-400 text-center mb-6 leading-relaxed">
                        계정이 생성되었습니다.<br />
                        관리자의 승인을 기다려주세요.
                    </p>

                    {/* Info Box */}
                    <div className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-4 mb-6">
                        <div className="flex items-start gap-3">
                            <CheckCircle className="w-5 h-5 text-blue-400 shrink-0 mt-0.5" />
                            <div className="text-sm text-blue-300">
                                <p className="font-bold mb-1">승인 대기 중</p>
                                <p className="text-blue-400/80 text-xs leading-relaxed">
                                    관리자가 계정을 승인하면 이메일로 알림이 발송됩니다.
                                    승인 후 로그인하여 서비스를 이용하실 수 있습니다.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Logout Button */}
                    <button
                        onClick={handleLogout}
                        className="w-full h-14 bg-slate-800 hover:bg-slate-700 text-white font-bold rounded-2xl flex items-center justify-center gap-2 transition-all active:scale-95 border border-slate-700"
                    >
                        <LogOut className="w-5 h-5" />
                        로그인 페이지로 돌아가기
                    </button>
                </div>

                {/* Footer */}
                <p className="text-center mt-6 text-slate-500 text-sm">
                    문의사항이 있으시면 고객센터로 연락주세요.
                </p>
            </div>
        </div>
    );
};

export default PendingApprovalPage;
